export default __webpack_public_path__ + "static/media/PRIMARY - GHOST_white.e2796fe6.svg";